import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';

export function NotFound() {
  return (
    <div className="min-h-screen bg-deep-night flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <h1 className="font-outfit text-8xl font-bold text-naia-pink mb-4">404</h1>
          <h2 className="font-outfit text-2xl font-semibold text-pearl-white mb-4">
            Page Not Found
          </h2>
          <p className="text-slate-grey text-lg">
            Sorry, the page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="flex items-center gap-2 px-6 py-3 bg-naia-pink text-pearl-white rounded-lg hover:bg-soft-violet transition-colors font-medium"
          >
            <HomeIcon />
            Go Home
          </Link>
          <Link
            to="/search"
            className="flex items-center gap-2 px-6 py-3 bg-white/10 text-pearl-white rounded-lg hover:bg-white/20 transition-colors font-medium"
          >
            <SearchIcon />
            Search Music
          </Link>
        </div>
      </div>
    </div>
  );
} 